<label class="form-label">Empregador</label>
<select
  class="form-select form-select-lg mb-3"
  [ngModel]="empregadorSelecionado"
  (ngModelChange)="selecionarEmpregador($event)">
  <option value="">Selecione</option>
  <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
</select>

<button
  type="button"
  class="btn btn-success btn-lg w-100 py-3"
  (click)="iniciarRegistro.emit()">
  Iniciar registro facial
</button>
